<template>
  <div class="marketing-nav-root">
    <div class="marketing-nav-bar fixed top-6 left-0 right-0 flex justify-center px-4 w-full pointer-events-none">
    <nav
      class="pointer-events-auto w-full max-w-7xl rounded-full glass-pill px-4 sm:px-6 md:px-8 lg:px-10 py-3 flex justify-between items-center gap-3 md:gap-6 relative"
      :class="{ scrolled: navbarScrolled }"
    >
      <router-link
        to="/landing"
        class="flex-shrink-0 flex items-center min-w-0 cursor-pointer hover:opacity-80 transition"
        @click.native="closeMobileMenu"
      >
        <img
          :src="logoUrl"
          alt="LaLANITAplus Logo"
          class="h-9 md:h-10 lg:h-11 rounded-xl w-auto max-h-11 mr-2 object-contain flex-shrink-0"
          :class="{ hidden: !logoLoaded }"
          @load="logoLoaded = true"
        >
        <span
          class="font-extrabold text-lg md:text-xl lg:text-2xl text-slate-800 tracking-tight whitespace-nowrap truncate"
          :class="{ hidden: logoLoaded }"
        >La<span class="text-green-500">LANITA</span>plus</span>
      </router-link>

      <div class="hidden md:flex items-center justify-end flex-shrink-0 gap-x-5 lg:gap-x-8 xl:gap-x-10">
        <router-link
          to="/landing#como-funciona"
          class="text-sm font-bold text-slate-600 hover:text-green-500 transition-colors whitespace-nowrap"
        >
          ¿Cómo funciona?
        </router-link>

        <router-link
          :to="variant === 'faq' ? '/centro-ayuda' : '/landing#faq'"
          class="text-sm font-bold transition-colors pb-1 whitespace-nowrap"
          :class="
            variant === 'faq'
              ? 'text-green-600 border-b-2 border-green-500'
              : 'text-slate-600 hover:text-green-500'
          "
        >
          Preguntas Frecuentes
        </router-link>

        <router-link
          to="/aviso-de-privacidad"
          class="text-sm font-bold transition-colors pb-1 whitespace-nowrap"
          :class="
            variant === 'privacy'
              ? 'text-green-600 border-b-2 border-green-500'
              : 'text-slate-600 hover:text-green-500'
          "
        >
          Aviso de Privacidad
        </router-link>

        <a
          href="https://app.adjust.com/1zfwxsn6"
          target="_blank"
          rel="noopener noreferrer"
          class="flex-shrink-0 bg-slate-900 text-white hover:bg-green-500 hover:shadow-lg hover:-translate-y-0.5 transform font-bold py-2.5 px-5 lg:px-6 rounded-full transition-all duration-300 text-sm shadow-sm whitespace-nowrap"
        >
          ¡Iniciar Sesión!
        </a>
      </div>

      <div class="md:hidden flex items-center">
        <button
          type="button"
          class="text-slate-800 hover:text-green-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-green-500 rounded-md p-1 -mr-1"
          aria-label="Menú"
          :aria-expanded="mobileMenuOpen"
          aria-controls="marketing-mobile-menu"
          @click="toggleMobileMenu"
        >
          <svg v-show="!mobileMenuOpen" class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
          <svg v-show="mobileMenuOpen" class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </nav>
    </div>

    <transition name="marketing-nav-backdrop">
      <div
        v-show="mobileMenuOpen"
        class="marketing-nav-backdrop md:hidden fixed inset-0 bg-slate-900/40"
        aria-hidden="true"
        @click="closeMobileMenu"
      />
    </transition>
    <transition name="marketing-nav-panel">
      <div
        v-show="mobileMenuOpen"
        id="marketing-mobile-menu"
        class="marketing-nav-panel md:hidden rounded-2xl bg-white shadow-2xl border border-slate-100 py-4"
        role="dialog"
        aria-modal="true"
        aria-label="Menú de navegación"
      >
        <div class="flex flex-col px-2">
          <button
            type="button"
            class="px-4 py-3 text-left text-base font-bold text-slate-700 hover:bg-slate-50 rounded-xl w-full border-0 bg-transparent cursor-pointer"
            @click="mobileNavigate('/landing#como-funciona')"
          >
            ¿Cómo funciona?
          </button>
          <button
            type="button"
            class="px-4 py-3 text-left text-base font-bold rounded-xl w-full border-0 bg-transparent cursor-pointer"
            :class="
              variant === 'faq'
                ? 'text-green-600 bg-green-50'
                : 'text-slate-700 hover:bg-slate-50'
            "
            @click="mobileNavigate(variant === 'faq' ? '/centro-ayuda' : '/landing#faq')"
          >
            Preguntas Frecuentes
          </button>
          <button
            type="button"
            class="px-4 py-3 text-left text-base font-bold rounded-xl w-full border-0 bg-transparent cursor-pointer"
            :class="
              variant === 'privacy'
                ? 'text-green-600 bg-green-50'
                : 'text-slate-700 hover:bg-slate-50'
            "
            @click="mobileNavigate('/aviso-de-privacidad')"
          >
            Aviso de Privacidad
          </button>
          <a
            href="https://app.adjust.com/1zfwxsn6"
            target="_blank"
            rel="noopener noreferrer"
            class="mx-4 mt-3 text-center bg-slate-900 text-white font-bold py-3 px-6 rounded-full shadow-md"
            @click="closeMobileMenu"
          >
            ¡Iniciar Sesión!
          </a>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
const LOGO_URL =
  'https://mxg-storage.obs.na-mexico-1.myhuaweicloud.com/Banner/debug/f20e22ef117ae593caf14c3e5ffcdb11.jpg'

export default {
  name: 'MarketingNav',
  props: {
    variant: {
      type: String,
      default: 'home',
      validator: (v) => ['home', 'faq', 'privacy'].includes(v)
    },
    navbarScrolled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      logoUrl: LOGO_URL,
      logoLoaded: false,
      mobileMenuOpen: false
    }
  },
  watch: {
    mobileMenuOpen(open) {
      if (typeof document === 'undefined') return
      document.body.style.overflow = open ? 'hidden' : ''
    },
    $route() {
      this.closeMobileMenu()
    }
  },
  mounted() {
    this._onKeydown = (e) => {
      if (e.key === 'Escape') this.closeMobileMenu()
    }
    window.addEventListener('keydown', this._onKeydown)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this._onKeydown)
    if (typeof document !== 'undefined') document.body.style.overflow = ''
  },
  methods: {
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false
    },
    /** 先完成路由再关菜单，避免移动端先隐藏菜单导致点击被吞 */
    mobileNavigate(to) {
      const p = this.$router.push(to).catch((err) => {
        if (err.name !== 'NavigationDuplicated') return Promise.reject(err)
      })
      p.finally(() => {
        this.mobileMenuOpen = false
      })
    }
  }
}
</script>

<style scoped>
/* 不依赖 Tailwind important 下的 z-*，避免遮罩盖住面板导致无法点击 */
.marketing-nav-bar {
  z-index: 68;
}
.marketing-nav-backdrop {
  position: fixed;
  inset: 0;
  z-index: 52;
}
.marketing-nav-panel {
  position: fixed;
  left: 1rem;
  right: 1rem;
  top: 5.5rem;
  z-index: 65;
  max-height: min(70vh, calc(100vh - 7rem));
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  pointer-events: auto;
}
.glass-pill {
  background-color: rgba(255, 255, 255, 0.96);
  box-shadow: 0 10px 40px -10px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.5);
  transition: background-color 0.35s cubic-bezier(0.4, 0, 0.2, 1),
    box-shadow 0.35s cubic-bezier(0.4, 0, 0.2, 1),
    padding-top 0.35s cubic-bezier(0.4, 0, 0.2, 1),
    padding-bottom 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}
.glass-pill.scrolled {
  background-color: rgba(255, 255, 255, 0.98);
  box-shadow: 0 15px 50px -10px rgba(0, 0, 0, 0.12);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.marketing-nav-backdrop-enter-active,
.marketing-nav-backdrop-leave-active {
  transition: opacity 0.2s ease;
}
.marketing-nav-backdrop-enter,
.marketing-nav-backdrop-leave-to {
  opacity: 0;
}
.marketing-nav-panel-enter-active,
.marketing-nav-panel-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.marketing-nav-panel-enter,
.marketing-nav-panel-leave-to {
  opacity: 0;
  transform: translateY(-0.5rem);
}
</style>
